// // Select the elements using querySelector and querySelectorAll
// var sizeElement = document.querySelector("body.product p.swatches__option-name.h5.Size");
// var sizeGuideTrigger = document.querySelector("body.product span.popup_content_link.size-guide-trigger.first-trigger");

// // Append the sizeGuideTrigger to the sizeElement
// if (sizeElement && sizeGuideTrigger) {
//   sizeElement.appendChild(sizeGuideTrigger);
// }


(function($){
  $(function(){
  });

  $( window ).on( "load", function() {

    if($('div.estimated_deliveryx').length > 0){
      var date_today = new Date(); //.getDay();
      var day_today_au = date_today.toLocaleString('en-AU', {timeZone: 'Australia/Sydney', weekday: 'short'});
      var hr_today_au = date_today.toLocaleString('en-AU', {timeZone: 'Australia/Sydney',hourCycle: 'h24', hour: '2-digit'});
  
      if( $.inArray(day_today_au, ['Fri','Sat','Sun']) !== -1 ){
        if( day_today_au == 'Fri' && hr_today_au < 15 ){
          $('div.estimated_delivery div.display').html('Ships in 24 hours');
          console.log('Ships in 24 hours');
        }
        else{
          $('div.estimated_delivery div.display').html('Ships next business day');
          console.log('Ships next business day');
        }
      }
      else{
        // Ships in 24 hours.
        $('div.estimated_delivery div.display').html('Ships in 24 hours');
        console.log('Ships in 24 hours.');
      }

      $('div.estimated_delivery').show();
    }

    // Move Afterpay notif below the estimated delivery - Product Page
    $("body.product .estimated_delivery").after($("body.product .product__section--header square-placement"));
      // $("body.product p.swatches__option-name.h5.Size").append($("body.product span.popup_content_link.size-guide-trigger.first-trigger")); 
  });
  
})(jQuery);
document.addEventListener("DOMContentLoaded", (event) => {
  document.querySelectorAll("body.product p.swatches__option-name.h5.Size").forEach(function(element) {
      var sizeGuideTrigger = document.querySelector("body.product span.popup_content_link.size-guide-trigger.first-trigger");
      if (sizeGuideTrigger) {
          element.append(sizeGuideTrigger);
          sizeGuideTrigger.style.display = "flex"
      }
  });
});


document.addEventListener("DOMContentLoaded", (event) => {
  if($('.ajax-cart__final-details').length){
  setInterval(function () {
   const elements = document.querySelectorAll('.ajax-cart__final-details');
    elements.forEach(function (element) {
        const totalText = element.querySelector('.subtotal-price .cart-original-total').textContent;
        const totalNumber = totalText.replace(/[^\d]/g, '');
        let currencySymbol = totalText.replace(/[0-9.,\s]/g, '');
    
        const afterPayElements = document.querySelectorAll('.ajax-cart__cart-form .after_pay_row_inner strong');
        afterPayElements.forEach(function (afterPayElement) {
            afterPayElement.innerHTML = `${currencySymbol.replace(/(IDR|Bds|EUR|ALL|DZD|AUD|XCD|BSD|BZD|USD|BOB|KYD|CRC|DKK|FJD|XPF|GBP|HKD|HUF|INR|IDR|ILS|JPY|MYR|MVR|MUR|PHP|PLN|QAR|SAR|XOF|SBD|LKR|SEK|CHF|TWD|THB|UAE)/g, '')} ${(totalNumber / 4 / 100).toFixed(2)}`;
        });
    });

  }, 1000);
  }
})

document.addEventListener("DOMContentLoaded", (event) => {
  if($('.product__section-details .price__pricing-group .price-item--regular').length){
   setInterval(function () {
     const proafterPay = document.querySelector('.product__section-details .price__pricing-group .price-item--regular').textContent;
     const PrototalNumber = proafterPay.replace(/[^\d]/g, '');
      let ProcurrencySymbol = proafterPay.replace(/[0-9.,\s]/g, '');
      document.querySelector('.product__section-details .after_pay_row_inner strong').innerHTML = `${ProcurrencySymbol.replace(/(IDR|Bds|EUR|ALL|DZD|AUD|XCD|BSD|BZD|USD|BOB|KYD|CRC|DKK|FJD|XPF|GBP|HKD|HUF|INR|IDR|ILS|JPY|MYR|MVR|MUR|PHP|PLN|QAR|SAR|XOF|SBD|LKR|SEK|CHF|TWD|THB|UAE)/g, '')} ${(PrototalNumber / 4 / 100).toFixed(2)}`;
      console.log('==========> ', `${ProcurrencySymbol} ${(PrototalNumber / 4 / 100).toFixed(2)}`)
    }, 1000);
  }
})


document.addEventListener('DOMContentLoaded', function () {
   // document.querySelectorAll(".product-listing__quickview-trigger").forEach(function(element) {
   //    element.addEventListener("click", function() {
         setInterval(function () {
            const afterPayBtn = document.querySelector(".after_pay_btn button");
            const afterPayImg = document.querySelector(".after_pay_img");
            const afterPayCloseIcon = document.querySelector(".after_pay_close_icon");
    
            if (afterPayBtn) {
                afterPayBtn.addEventListener("click", function() {
                    afterPayImg.style.display = "flex";
                });
            }
    
            if (afterPayCloseIcon) {
                afterPayCloseIcon.addEventListener("click", function() {
                    afterPayImg.style.display = "none";
                });
            };
  
           function handleSwatchClick(event) {
            const clickedInput = event.target;
            if (clickedInput.tagName === 'INPUT' && clickedInput.hasAttribute('data-inventort')) {
                const inventory = parseInt(clickedInput.getAttribute('data-inventort'), 10);
                const itemsLeftText = document.querySelector('.quick_view_box .items_left_text');
                const itemsLeftTextParnt = document.querySelector('.modal__container.modal--active .quick_view_box');
                let displayText;
                if (inventory === 0) {
                    displayText = 'Sold Out';
                    itemsLeftTextParnt.classList.remove('lowe_value'); 
                    itemsLeftTextParnt.style.display = 'none'
                } else if (inventory >= 1 && inventory <= 4) {
                    displayText = `${inventory} item${inventory === 1 ? '' : 's'} left`;
                    itemsLeftTextParnt.classList.add('lowe_value')
                    itemsLeftTextParnt.style.display = 'flex'
                } else if (inventory >= 5) {
                    displayText = 'In Stock';
                    itemsLeftTextParnt.classList.remove('lowe_value');
                    itemsLeftTextParnt.style.display = 'flex'
                }
                if (itemsLeftText) {
                    itemsLeftText.textContent = displayText;
                }
            }
        }
        
        function checkInitialSelection() {
            const selectedColorInput = document.querySelector('.swatches__swatch--color input[type="radio"]:checked');
            if (selectedColorInput) {
                handleSwatchClick({ target: selectedColorInput });
            }
            const selectedSizeInput = document.querySelector('.swatches__swatch--regular input[type="radio"]:checked');
            if (selectedSizeInput) {
                handleSwatchClick({ target: selectedSizeInput });
            }
        }
        const colorInputs = document.querySelectorAll('.swatches__swatch--color input[type="radio"]');
        colorInputs.forEach(input => {
            input.addEventListener('click', handleSwatchClick);
        });
        const sizeInputs = document.querySelectorAll('.swatches__swatch--regular input[type="radio"]');
        sizeInputs.forEach(input => {
            input.addEventListener('click', handleSwatchClick);
        });
           checkInitialSelection();
         }, 1000)
  //     });
  // });
});